// React imports
import { useRef } from "react";

// Hooks & Components (react-hook-form) imports
import { useForm } from "react-hook-form";

// Third helpers imports
import { toast } from "react-toastify";

// Custom helpers imports
import { confirmChange } from "../../../../features/auth/helpers";
import { userStatusInfo } from "../../../../features/auth/helpers";

// Custom queries imports
import { useChangeStatusUserMutation } from "../../../../features/users/useChangeStatusUserMutation";

// Hooks (@tanstack/react-query) imports
import { useQueryClient } from "@tanstack/react-query";

// Custom types imports
import { Roster, RosterModel } from "../../../../features/roster/types";
import { USER_STATUS } from "../../../../features/users/types";

interface Props {
  roster: Roster;
  paramsRostersInfinite: RosterModel;
}

function UpdateStatusRoster({ roster, paramsRostersInfinite }: Props) {
  const queryClient = useQueryClient();
  const inputSubmitRef = useRef<HTMLInputElement | null>(null);
  const methods = useForm<{ status: USER_STATUS }>({
    defaultValues: {
      status: roster.userStatus,
    },
  });

  const changeStatusUserMutation = useChangeStatusUserMutation(
    (_data, variables) => {
      toast.update(variables.notificationID, {
        type: "info",
        isLoading: false,
        autoClose: 5000,
        render: "Estado del usuario actualizado",
      });
      queryClient.invalidateQueries([
        "RosterInfinite",
        ...Object.values(paramsRostersInfinite),
      ]);
    },
    (error, variables) => {
      toast.update(variables.notificationID, {
        type: "error",
        isLoading: false,
        autoClose: 5000,
        render:
          error.data?.description ||
          "¡Algo salio mal!, al intentar cambiar el estado del usuario",
      });
    }
  );

  const onSubmit = methods.handleSubmit((data) => {
    const notificationID = toast.loading("Cambiando estado del usuario...");
    changeStatusUserMutation.mutate({
      email: roster.email,
      status: data.status,
      notificationID,
    });
  });

  return (
    <form onSubmit={onSubmit}>
      <div className=" border-y w-full px-4 py-3 flex justify-between items-center flex-wrap">
        <span className="text-gray-600">Estado del usuario</span>
        <div className="gap-x-2 sm:mt-0 mt-2 w-full sm:w-[60%] flex justify-end items-center">
          <div className="w-full flex items-center relative">
            <select
              className="input-base pr-[40px] overflow-hidden appearance-none cursor-pointer"
              placeholder="Correo electrónico"
              {...methods.register("status")}
            >
              <option value={USER_STATUS.Active}>
                {userStatusInfo(USER_STATUS.Active).description}
              </option>
              <option value={USER_STATUS.Inactive}>
                {userStatusInfo(USER_STATUS.Inactive).description}
              </option>
              <option value={USER_STATUS.Blocked}>
                {userStatusInfo(USER_STATUS.Blocked).description}
              </option>
              <option value={USER_STATUS.Suspended}>
                {userStatusInfo(USER_STATUS.Suspended).description}
              </option>
            </select>
            <i className="text-gray-500 text-[20px] absolute z-10 right-[13px] bi bi-chevron-down"></i>
          </div>
          <button
            type="button"
            onClick={() =>
              confirmChange(
                "¿Estas seguro de modificar el estado del usuario?",
                "",
                () => {
                  if (!!inputSubmitRef.current) {
                    inputSubmitRef.current.click();
                  }
                }
              )
            }
            disabled={!methods.formState.isDirty}
            className="button-third bg-blue-500 hover:bg-blue-600 text-white text-sm py-2 px-4"
          >
            Cambiar
          </button>
          <input className="hidden" ref={inputSubmitRef} type="submit" />
        </div>
      </div>
    </form>
  );
}
export default UpdateStatusRoster;
